const LOCALE_STORAGE_KEY = 'locale'

const I18N_LOCALE_MAP: Record<string, string> = {
  en_US: 'en',
  'en-US': 'en',
  en_GB: 'en',
  'en-GB': 'en',
  fr: 'fr_FR',
  'fr-FR': 'fr_FR',
  'fr-CA': 'fr_CA',
  pt: 'pt_PT',
  'pt-PT': 'pt_PT',
  'pt-BR': 'pt_BR',
  'es-ES': 'es',
  'de-DE': 'de',
  'it-IT': 'it',
  'nl-NL': 'nl',
  'da-DK': 'da',
  'fi-FI': 'fi',
  'nb-NO': 'no',
  'sv-SE': 'sv',
}

// Resolves a raw locale string to a registered vue-i18n message key
export function resolveLocale(raw: string | null | undefined): string {
  if (!raw || raw === 'undefined') return 'en'
  return I18N_LOCALE_MAP[raw] ?? raw
}

/**
 * Reads the raw locale from localStorage and resolves it for vue-i18n.
 * Falls back to 'en' if nothing is stored or a bad value was written by a sibling app.
 */
export function getI18nLocale(): string {
  return resolveLocale(localStorage.getItem(LOCALE_STORAGE_KEY))
}

export function saveLocale(locale: string): void {
  localStorage.setItem(LOCALE_STORAGE_KEY, locale)
}
